export function getCookieDomain() {
  const hostName = window.location.hostname;

  // If we're in development mode and we're NOT using the myqsrsfot.com domain
  // then we'll just use localhost.
  // TODO maybe we want to consider other options, like IP addresses as well.
  if (
    process.env.NODE_ENV === 'development' &&
    !hostName.includes('myqsrsoft.com')
  ) {
    return 'localhost';
  }

  // Contrary to what was done before, we don't need to prepend the domain
  // with a period.
  return 'myqsrsoft.com';
}

// We'll use secure ONLY if we're in production.
// If we're in development mode, we'll need to use http.
export function getSecureCookie() {
  return !(process.env.NODE_ENV === 'development');
}
